import { render } from "./factory_stock_mail_detail.vue?vue&type=template&id=357b0d7b"
import script from "./factory_stock_mail_detail.vue?vue&type=script&lang=js"
export * from "./factory_stock_mail_detail.vue?vue&type=script&lang=js"

import exportComponent from "/drone/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__